import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, Button, DialogFooter} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';

export type ApplyToAllWarningDialogProps = {
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
};

const ApplyToAllWarningDialog = ({open, onContinue, onCancel}: ApplyToAllWarningDialogProps) => {
  const {t} = useTranslation();
  const ui = useUiState();

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('str_TitleWarning')}
      showTitle={false}
      aria-live="assertive"
    >
      <DialogContent>{t('calendars:str_ApplyToAllCalendarWarning')}</DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button label={t('*:str_ButtonCancel')} buttonStyle={'secondary'} onClick={onCancel} />
        <Button label={t('*:str_ButtonContinue')} onClick={onContinue} />
      </DialogFooter>
    </Dialog>
  );
};

export default ApplyToAllWarningDialog;
